/**
 * Internal Dependencies
 */
import axiosInstance, { httpErrorHandler } from '@/services/http.js';

const getDocument = (id, params) => {
	return axiosInstance
		.get(`/documents/${id}`, {
			params
		})
		.then((res) => httpErrorHandler(res));
};

const deleteDocument = (id) => {
	return axiosInstance.delete(`/documents/${id}`).then((res) => httpErrorHandler(res));
};

const addDocument = (params) => {
	const formData = new FormData();
	formData.append('file', params.file);
	if (params.file.size > 50 * 1024 * 1024) {
		return Promise.reject({
			message: "This file exceeds the upload size limit (50MB). Please amend the document by removing excess pages."
		});
  }

	formData.append('krt', params.krt);
	formData.append('owner', params.owner);
	formData.append('organizations', params.organizations);
	for (let i = 0; i < params.attachedFiles.length; i++) {
		formData.append(`attachedFiles`, params.attachedFiles[i]);
	}
	formData.append('mergePDFs', params.mergePDFs);
	formData.append('mute', params.mute);
	formData.append('dataseerML', params.dataseerML);
	formData.append('bioNLP', params.bioNLP);
	formData.append('importDataFromBioNLP', params.importDataFromBioNLP);
	formData.append('refreshDataObjectsSuggestedProperties', params.refreshDataObjectsSuggestedProperties);
	formData.append('importDataFromKRT', params.importDataFromKRT);
	formData.append('deleteDataObjects', params.deleteDataObjects);
	formData.append('softcite', params.softcite);
	formData.append('importDataFromSoftcite', params.importDataFromSoftcite);
	formData.append('ignoreSoftCiteCommandLines', params.ignoreSoftCiteCommandLines);
	formData.append('ignoreSoftCiteSoftware', params.ignoreSoftCiteSoftware);
	formData.append('removeResponseToViewerSection', params.removeResponseToViewerSection);

	return axiosInstance
		.post(`/documents`, formData, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
		.then((res) => httpErrorHandler(res));
};

const updateDocument = (id, params) => {
	return axiosInstance
		.put(`/documents/${id}`, params)
		.then((res) => httpErrorHandler(res));
};

const updateDocumentMetadata = (id, params) => {
	return axiosInstance
		.post(`/documents/${id}/metadata/reload`, params)
		.then((res) => httpErrorHandler(res));
};

const getDocuments = (params) => {
	return axiosInstance.get(`/documents`, { params }).then((res) => {
		httpErrorHandler(res);

		return {
			count: res.data.count,
			data: res.data.res
		};
	});
};

const getDocumentLogs = (id) => {
	return axiosInstance.get(`/documents/${id}/logs`).then((res) => httpErrorHandler(res));
};

const getDocumentPdf = (id, params) => {
	return axiosInstance
		.get(`/documents/${id}/pdf`, {
			params
		})
		.then((res) => res.data);
};

const getDocumentPdfUrl = (id, docToken) => {
	return axiosInstance
		.get(`/documents/${id}/pdf/content`, {
			responseType: 'blob'
		}, { token: docToken })
		.then((res) => {
			return URL.createObjectURL(res.data);
		});
};

const getDocumentTei = (id, params) => {
	return axiosInstance
		.get(`/documents/${id}/tei`, {
			params
		})
		.then((res) => res.data);
};

const getDocumentTeiContent = (id, params) => {
	return axiosInstance
		.get(`/documents/${id}/tei/content`, {
			params
		})
		.then((res) => res.data);
};

const getDocumentGoogleReportsInfos = ({ id, kind }, params) => {
	return axiosInstance
		.get(`/documents/${id}/reports/gSpreadsheets/${kind}`, {
			params
		})
		.then((res) => res.data);
};

const getDocumentReport = (id) => {
	return axiosInstance
		.get(`/documents/${id}/reports/json/default`)
		.then((res) => res.data);
};

const getJsonDataTypes = (params) => {
	return axiosInstance
		.get(`/dataseer-ml/jsonDataTypes`, {
			params
		})
		.then((res) => res.data);
};

export default {
	getDocuments,
	getDocument,
	addDocument,
	updateDocument,
	updateDocumentMetadata,
	deleteDocument,
	getDocumentPdf,
	getDocumentPdfUrl,
	getDocumentTei,
	getDocumentTeiContent,
	getDocumentGoogleReportsInfos,
	getDocumentLogs,
	getDocumentReport,
	getJsonDataTypes
};
